const ChevronExpand: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.195825 13.067C0.320876 12.9326 0.490672 12.8571 0.667745 12.8571C0.844818 12.8571 1.01461 12.9326 1.13967 13.067L6.00017 18.277L10.8607 13.067C11.1213 12.7877 11.5439 12.7877 11.8045 13.067C12.0652 13.3463 12.0652 13.7991 11.8045 14.0784L6.4721 19.7927C6.34704 19.9271 6.17725 20.0026 6.00017 20.0026C5.8231 20.0026 5.65331 19.9271 5.52825 19.7927L0.195825 14.0784C0.0704575 13.9444 0 13.7625 0 13.5727C0 13.383 0.0704575 13.201 0.195825 13.067ZM0.195825 6.93556C0.320876 7.06991 0.490672 7.14541 0.667745 7.14541C0.844818 7.14541 1.01461 7.06991 1.13967 6.93556L6.00017 1.72556L10.8607 6.93556C11.1213 7.21486 11.5439 7.21486 11.8045 6.93556C12.0652 6.65627 12.0652 6.20343 11.8045 5.92413L6.4721 0.209848C6.34704 0.075503 6.17725 0 6.00017 0C5.8231 0 5.65331 0.075503 5.52825 0.209848L0.195825 5.92413C0.0704575 6.05814 0 6.2401 0 6.42985C0 6.6196 0.0704575 6.80156 0.195825 6.93556Z"
      fill="currentColor"
    />
  </svg>
);

export default ChevronExpand;
